(function(EF, undefined) {

  var Question = Backbone.Model.extend({
    initialize: function(attrs, options) {
      this.parse(attrs);
    },
    parse: function(json) {
      this.answers = new EF.Collections.AnswersCollection(json.answers);
      return json;
    }
  });


  _.extend(EF.Models, {
    Question: Question
  });

})(EF);
